import { Footer } from '../footer/view';
import { Header } from '../header/view';
import React from 'react';
import ImportantNoticeBar from '@Components/important_notice_bar/view';

import s from './style.module.css';

type PageProps = {
    contentHead?: React.ReactNode;
    contentFooter?: React.ReactNode;
    courseId?: string;
    isInquiry?: boolean;
    // SSR時のヘッダー「選択中」ナビ判定（getPathResolver）用の実際のリクエストパス。
    // 呼び出し元（Detail/DetailSp）がrailsContext.pathnameから渡す（PR #2082 Point2対応）
    currentPath?: string;
    children: React.ReactNode;
};
const Page: React.VFC<PageProps> = (props: PageProps) => {
    return (
        <div className={s.page}>
            <Header courseId={props.courseId} isInquiry={props.isInquiry} currentPath={props.currentPath} />
            <ImportantNoticeBar />
            <div className={s.page_wrap}>
                <div>{props.contentHead}</div>
                <div className={s.body}>
                    <div className={s.page_contents}>{props.children}</div>
                </div>
                {props.contentFooter}
            </div>
            <Footer courseId={props.courseId} />
        </div>
    );
};
export default Page;
